module.exports = window.AssetManagerServices;